import { DrawerHeaderTitle, DrawerHeaderTitleProps } from '@fluentui/react-components';


interface DrawerHeaderTitleCustomProps {
    rcName?: string;   
}

const DrawerHeaderTitleCustom = (props: DrawerHeaderTitleCustomProps & DrawerHeaderTitleProps) => {
    return (
        <DrawerHeaderTitle {...props}/>
    );
};

export default DrawerHeaderTitleCustom;